import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { isTrialExpired } from 'utils/freeTrials';

import Paragraph from 'components/Paragraph';
import { Date } from 'apps/components/date';
import { Div } from 'legacyComponents/styled/lib';

import { SmallPrint, UpgradeText } from 'apps/payment/styles';

export const PlanDetails = withNamespaces()(
  observer(({ paymentSpace }) => {
    if (!paymentSpace) return null;
    const {
      subscription,
      inSpace: { trialPeriodEnd },
    } = paymentSpace;
    if (!subscription) return null;
    const {
      displayNextAmount,
      currentPeriodEnd,
      cancelAtPeriodEnd,
    } = subscription;
    const isTrialActive = trialPeriodEnd && !isTrialExpired(trialPeriodEnd);
    if (cancelAtPeriodEnd && !trialPeriodEnd) {
      return (
        <Div width='50%' display='inline-block' verticalAlign='top'>
          <Paragraph>
            <Trans>Status</Trans>:{' '}
            <u>
              <Trans>Cancelled</Trans>
            </u>
          </Paragraph>
          <Paragraph>
            <Trans>Expires on</Trans>:{' '}
            <u>
              <Date
                value={isTrialActive ? trialPeriodEnd : currentPeriodEnd}
                noRelative
              />{' '}
            </u>
          </Paragraph>
          <Paragraph>
            <SmallPrint>
              <Trans>Changed your mind?</Trans>{' '}
              <UpgradeText onClick={paymentSpace.Reactivate}>
                <Trans>Re-activate Subscription</Trans>
              </UpgradeText>
              .
            </SmallPrint>
          </Paragraph>
        </Div>
      );
    }
    const { seats } = subscription;
    const { includedPlanSeats } = seats;
    return (
      <Div width='50%' display='inline-block' verticalAlign='top'>
        {subscription.isGrandFatherPlan ? (
          <Paragraph>
            <strong>
              <Trans>Free private collaborators</Trans>:
            </strong>{' '}
            <u>{includedPlanSeats}</u>
          </Paragraph>
        ) : (
          <Paragraph>
            <strong>
              {isTrialActive ? (
                <Trans>Trial expires</Trans>
              ) : (
                <Trans>Next payment due</Trans>
              )}
            </strong>
            :{' '}
            <u>
              <Date
                value={isTrialActive ? trialPeriodEnd : currentPeriodEnd}
                noRelative
              />{' '}
            </u>
          </Paragraph>
        )}
        {!isTrialActive && (
          <Paragraph>
            <strong>
              <Trans>Next payment amount</Trans>:
            </strong>{' '}
            <u>{displayNextAmount}</u>
          </Paragraph>
        )}
      </Div>
    );
  }),
);

PlanDetails.propTypes = {
  subscription: PropTypes.object,
};
